<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ "Reprint Ticket Report " }}
        </div>       
        <div class="d-flex align-items-center">         
          <div class="d-flex align-item-center">
                <input value="1" type="radio" v-model="lang_id">
                <span class="ml-1">English</span>
              </div>
              <div class="d-flex align-item-center ml-2">
              <input value="2" type="radio" v-model="lang_id">

              <span class="ml-1">العربية</span>
            </div>
        </div>
      </div>
      <div>
          <small><em>{{ $t("* As Per Business Date") }}</em></small>
        </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.selectedCinema ? 'shift-up' : 'font-weight-bold'"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                             :disabled="isRoleID"
                             :options="dropDown.cinemas"
                             v-model="dropDown.selectedCinema"
                             :searchable="true"
                             label="cine_name"
                             track-by="cine_id"
                             placeholder="Movie"
                             @input="onSelectCinema($event)"
                             :allowEmpty="false"
                             :showLabels="false"
                           ></multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                            <Datepicker
                :monday-first="true"
                type="date"
                ref="programaticOpen"
                v-model="fromDate"
                v-validate="'required'"
                @selected="onChangeDate($event, 'from')"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">
                <!-- {{ $t("show") }} -->
                {{ $t("fromdate") }}
              </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>    
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label :class="selectedMovieName && selectedMovieName.length > 0 ? 'shift-up' : 'font-weight-bold'">
              {{ selectedMovieName && selectedMovieName.length > 0 ? $t("Movies") : $t("All Movies") }}
            </label>
            <multiselect v-model="selectedMovieName" :options="allMovieNames" track-by="movie_name"
              label="movie_name" :disabled="isRoleID" :searchable="true" placeholder="Movies" :multiple="true">
            </multiselect>
          </div>
        </div>

         <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label :class="selectedScreenName && selectedScreenName.length > 0 ? 'shift-up' : 'font-weight-bold'">
              {{ selectedScreenName && selectedScreenName.length > 0 ? $t("Screens") : $t("All Screens") }}
              </label>
            <multiselect v-model="selectedScreenName" :options="allScreenNames" track-by="screen_name"
              label="screen_name" :disabled="isRoleID" :searchable="true" placeholder="Screens" :multiple="true">
            </multiselect>
          </div>
        </div> 

        <!-- show time filter -->
                  <div class="position-relative col-lg-3 col-xl-2 mb-2">
                    <vue-timepicker manual-input
                     v-model="start_time"
                      id="starttime"
                      name="starttime"
                      :placeholder="$tc('starttime')"
                       format="HH:mm"
                       class="time_picker"
                       input-width="100%"
                       auto-scroll
                      lazy ></vue-timepicker>
                  </div>
       
          <div class="position-relative col-lg-3 col-xl-2 mb-2">
  <vue-timepicker
    manual-input
    v-model="end_time"
    id="endtime"
    name="endtime"
    :placeholder="$tc('endtime')"
    format="HH:mm"
    class="time_picker"
    input-width="100%"
    auto-scroll
    lazy
  />
</div>
        <!-- show time filter -->

        <!-- Payment mode filter -->
        <div class="col-12 col-md-6 col-lg-3 col-xl-3  mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedPaymentSource && selectedPaymentSource.length > 0
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                > {{ selectedPaymentSource && selectedPaymentSource.length > 0 ? $t("Payment Mode") : $t("All Payment Mode") }}</label
              >
              <multiselect
                :options="paymentList"
                v-model="selectedPaymentSource"
                placeholder=""
                label="pm_payment_mode"
                :multiple="true"
                :close-on-select="false"
                track-by="pm_id"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
        <!-- Payment mode filter -->

        <!-- User Filter -->
             <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
                       <div class="dropdown-curve-container">
                         <label
                           :class="
                              selectedUsers && selectedUsers.length > 0
                               ? 'shift-up'
                               : 'font-weight-bold'
                           "
                           > {{ selectedUsers && selectedUsers.length > 0 ? $t("User") : $t("All Users") }}</label
                         >
                         <multiselect
                           :options="Users"
                           v-model="selectedUsers"
                           placeholder=""
                           label="username"
                           :multiple="true"
                           :close-on-select="true"
                           track-by="user_id"
                         ></multiselect>
                       </div>
                     </div>
        <!-- User Filter -->

        <!-- Distributor Filter -->
            <div class="col-lg-6 col-xl-3 mb-4">
                     <div class="d-flex align-items-center">
                       <div class="dropdown-curve-container">
                         <label :class="selectedDistributor.length > 0 ? 'shift-up' : 'font-weight-bold'">
                          {{ selectedDistributor && selectedDistributor.length > 0 ? $t("Distributors") : $t("All Distributors") }}
                         </label>
         
                         <multiselect v-model="selectedDistributor" @input="onSelectHandler($event, 'distributor')"
                           @remove="onRemoveHandler($event, 'distributor')" placeholder=""
                           :options="getDistributorReportDropdownList" label="d_company_name" track-by="d_id" :multiple="true"
                           name="d_id" id="d_id" select-label="Select" deselect-label="Remove">
                         </multiselect>
                       </div>
                     </div>
                   </div>
        <!-- Distributor Filter -->
        
          <div class="col-12 col-md-6 col-lg-6 col-xl-1 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
             
            </button>
          </div>
          <div
            v-if="reprintData.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getReprintTicketData('Y', 'N')"
              title="Download as Excel"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getReprintTicketData('N', 'Y')"
              title="Download as PDF"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div class="swc-report">
          <table
class="swc-report-table"
:class="lang_id == 2 ? 'swc-report-table reverse-order' : 'swc-report-table order'"
border="1"
>
<thead class="bg-lightgrey">
  <tr :class="lang_id == 2 ? 'text-right' : 'text-center'">
    <th>{{ trans("screen", lang_id) }}</th>
    <th>{{ trans("movie", lang_id) }}</th>
    <th>{{ trans("selling_time", lang_id) }}</th>
     <th>{{ trans("reprint_time", lang_id) }}</th>
    <th>{{ trans("ref_code", lang_id) }}</th>
    <th>{{ trans("show_date", lang_id) }}</th>
    <th>{{ trans("show_time", lang_id) }}</th>
    <th>{{ trans("authorized_by", lang_id) }}</th>
    <th>{{ trans("reprint_qty", lang_id) }}</th>
    <th>{{ trans("ticket_price", lang_id) }}</th>
    <th>{{ trans("ticket_quantity", lang_id) }}</th>
  </tr>
</thead>

<tbody v-if="reprintData.length">
  <tr  v-for="(data, index) in reprintData"
  :key="index"> 
    <td class="text-left">{{ lang_id == 1 ? data.screen_name : (data.alternate_screen_name_language || data.screen_name) }}</td>
    <td class="text-left">{{ lang_id == 1 ? data.movie_name : (data.alternate_movie_name_language || data.movie_name) }}</td>
    <td class="text-right">{{ moment(data.t_booking_date_time).format("YYYY-MM-DD HH:mm") }}</td>
    <td class="text-right">{{ moment(data.created_at).format("YYYY-MM-DD HH:mm") }}</td>
    <td class="text-right">{{ data.ref_no }}</td>
    <td class="text-right">{{ moment(data.t_show_date).format("YYYY-MM-DD") }}</td>
    <td class="text-right">{{ data.t_show_time }}</td>
    <td class="text-left">{{ data.username || data.booking_user_name }}</td>
    <td class="text-right">{{ data.reprint_count }}</td>
    <td class="text-right">{{ data.ticket_price * data.ticket_quantity }}</td>
    <td class="text-right">{{ data.ticket_quantity }}</td>
  </tr>
</tbody>

<tbody v-else>
  <tr>
    <td colspan="18" class="text-center">No Record</td>
  </tr>
</tbody>
</table>

      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import NewReportService from "../../../services/NewReportService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
 import ReportService from "@/services/ReportsService";
 import { authenticationService } from "@/services/AuthenticationService";
import * as XLSX from "xlsx";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
    VueTimepicker
  },
  data() {
    return {
        selectedDistributor:[],
       selectedUsers:[],
       Users:[],
      end_time: "",
      start_time: "",
      BASEURL,
      isRoleID: false,
      submitted: false,
      lang_id:"1",
     
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCineAddress: ""
      },
      selectedCinema:[],
      reprintData: [],
      selectedScreen:[],

      fromDate: null,
      toDate: null,
      grandTotal: {},
      selectedMovieName: [],
      allMovieNames: [],
      selectedScreenName:[],
      allScreenNames:[],
       selectedPaymentSource:[],
       paymentList:[],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.getPaymentTypes();
    this.getUsers();
    this.fetchReportDistributorsList();

  },
  watch: {
    fromDate() {
    this.getReprintTicketData("N", "N", "filter");
    this.getReprintTicketData("N", "N", "filter2");
  },
  toDate() {
    this.getReprintTicketData("N", "N", "filter");
    this.getReprintTicketData("N", "N", "filter2");
  },
  },
  mounted() {},
  computed: {
     distributorIds() {
          let text = ``;
          if (this.selectedDistributor.length > 0) {
            text = this.selectedDistributor.map(x => x.d_id).join(",");
          }
    
          return text;
        },
         ...mapGetters([
          "getDistributorReportDropdownList"
          //   "getDistributorReportMoviesList",
        ]),
    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
    paymentModeId() {
      let text = ``;
      if (this.selectedPaymentSource.length > 0) {
        text = this.selectedPaymentSource.map(x => x.pm_id).join(",");
      }

      return text;
    }
  },
  methods: {
    moment,
onSelectHandler(event,type){
        if (type =="distributor") {
        this.d_id = event.d_id;
        // this.selectedMovie = [];
        // this.MovieList = [];
         this.fetchDistributorMovies();
        // this.selectedDistributor = event;
      }
      },
       onRemoveHandler(event,type){
              
          },
    fetchDistributorMovies() {
      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show("Please Select Cinema");
        this.selectedDistributor = [];
        this.$forceUpdate();
      } else {
        this.MovieList = [];
        let payload = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          cinema_id: this.dropDown.selectedCinemaId,
            cinema_name: this.dropDown.selectedCinemaName,
            cinema_address: this.dropDown.selectedCinemaAddres,
          d_id: this.distributorIds,
          d_company_name: this.selectedDistributor
            .map(x => x.d_company_name)
            .join(","),
          country_id: authenticationService.get("BRGLOPCO"),
          filter_with_key: "ss_actual_start_date"
        };
        ReportService.GetDistributorMovieFormat(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records) {
              this.MovieList = data.Records;
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch(error => {
            this.$toasted.show(
              "Catch Error on ReportStore fetchDistributorMovies",
              error
            );
          });
      }
    },
    async getUsers(index) {
        try {
          const response = await MasterService.GetActiveList({
            tableName: "users",
            is_active: "Y",
          });
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records.filter(user=>user.role_id==4);
           // console.log("Users",this.Users)
          } else {
            console.log("show error:", data.message);
          }
        } catch (error) {
          this._CatchError(error);
        }
      },
      getPaymentTypes() {
          let body = {
            tableName: "ms_payment_modes",
            pm_is_active: "Y"
          };
          MasterService.GetActiveList(body).then(response => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.paymentList = data.Records;
               
              }
            } else this.$toasted.show(data.message || "Opps! Something went wrong");
          });
        },
    onChangeDate(e, type){
    if(type == 'from'){
      this.toDate = new Date(e);
      this.$forceUpdate();
    }
  },
      getCinemaList: function () {
          MasterService.GetCinemas()
            .then((response) => {
              const { data } = response;
              if (data.status && data.Records.length > 0) {
                this.dropDown.cinemas = data.Records;
                this.CinemasCopy = data.Records;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        },
  onSelectCinema: function (event) {
       this.dropDown.selectedCinema = event;
       this.dropDown.selectedCinemaName = event.cine_name;
       this.dropDown.selectedCinemaId = event.cine_id;
       this.dropDown.selectedCinemaAddres = event.cine_address;
       this.$store.dispatch("selectDropdownCinema", event);
     },
    onSubmit() {
      this.getReprintTicketData("N","N");
    },

  async getReprintTicketData( isExcel = "N", isPdf = "N", type = "") {
 if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
if (!this.fromDate) {
  return this.$toasted.show("Select From Date");
}

let loader;
try {
  let cinemaIds = [];
  let cinemaName = "";
  let cinemaAddress = "";
  let user_id = [];
          if (this.selectedUsers.length) {
            user_id = this.selectedUsers.map((user_ids) => ({ user_id: user_ids.user_id, username: user_ids.username }));
          }

  if (this.selectedCinema.length) {
    if (this.selectedCinema[0].cine_id === 0) {
      cinemaIds = this.CinemasCopy.map(cinema => cinema.cine_id);
      cinemaName = "All Cinemas";
      cinemaAddress = ""; 
    } else {
      cinemaIds = this.selectedCinema.map(cinema => cinema.cine_id);
      cinemaName = this.selectedCinema.map(cinema => cinema.cine_name).join(", ");
      cinemaAddress = this.selectedCinema.map(cinema => cinema.cine_address).join(", ");
    }
  }

  this.reprintData = [];
  loader = this.$loading.show();
  let payload = {
     cinema_id: this.dropDown.selectedCinemaId,
    cinema_name: this.dropDown.selectedCinemaName,
    cinema_address: this.dropDown.selectedCinemaAddres,
    fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
    toDate: moment(this.toDate).format("YYYY-MM-DD"),
    lang_id: this.lang_id,
    start_time:this.start_time,
    end_time:this.end_time,
    payment_mode_id:this.paymentModeId,
    user_id : user_id.map(p=>p.user_id),
    username : user_id.map(p=>p.username), 
   
    d_id: this.distributorIds,
    d_company_name: this.selectedDistributor.map(x => x.d_company_name).join(","),
    payment_name: this.selectedPaymentSource.map(x =>x.pm_payment_mode).join(","),
    isPdf,
    isExcel
  };
  if (type === "filter") {
    payload["type"] = "filter";
  }

    if (this.selectedMovieName.length) {
      payload["selectedMovieName"] = this.selectedMovieName.map(
        (item) => {
          return item.movie_name;
        }
      );
    }
    if (type === "filter2") {
    payload["type"] = "filter2";
  }
    if (this.selectedScreenName.length) {
      payload["selectedScreenName"] = this.selectedScreenName.map(
        (item) => {
          return item.screen_name;
        }
      );
    }

  let response = await NewReportService.getTicketReprintReport(payload);
  const { data } = response;
  if (!data.status) return this.$toasted.show(data.message);
    if (type == "filter") {
          this.allMovieNames = [...data.movieNamesData];
        } 
        else if (type === "filter2") {
    this.allScreenNames = [...data.screenNamesData]; 
  }
        else {
    this.reprintData = data.Records;
    if (isPdf == "Y" && data.pdfPath) {
      window.open(data.pdfPath, "_blank");
    }
    if (isExcel == "Y" && data.excelPath) {
      window.open(data.excelPath, "_blank");
    }
    this.$toasted.show(data.message);
  } 
  loader.hide();

} catch (error) {
  console.log(error);
} finally {
  if (loader) {
    loader.hide();
  }
}
},
  ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      // "fetchDistributorsList",
      // "fetchDistributorsActiveMasterMovie",
      // FETCH LIST ONLY
      "fetchReportDistributorsList",
      "fetchDistributorReportList",
      "onDistributorReportDateHandler",
      "onDistributorReportDropdownHandler",
      "onDistributorReportFlagHandler",
      "onResetDistributorStoreState"
    ])
  }
};
</script>


<style scoped>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.rtl-table-scroll {
  direction: rtl;
}

.color-blue {
  background-color: #cccccc;
}
.text-bold {
  font-weight: bold;
}
.rtl-table {
  display: flex;
  flex-direction: row-reverse; /* Reverse column order */
}

.rtl-table td {
  text-align: right; /* Align text properly for Arabic */
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: blue !important;
  border-color: blue !important;
}
.reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}

/* Change radio button color */
.j-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: red !important; /* Change the radio background color */
  border-color: red !important; /* Change the border color */
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/ticketReprint.vue